const PAGE_CATEGORY = 'account';

const buildAdobePageName = (pagePath: string) =>
  `cvs|web|${PAGE_CATEGORY}|${pagePath.replace(/:/g, '|')}`;

const buildPageName = (pagePath: string) =>
  `${PAGE_CATEGORY}:${pagePath}`;

const utagLink = (payload: Record<string, unknown>) => {
  try {
    if (typeof window !== 'undefined' && window['utag']) {
      setTimeout(() => window['utag'].link(payload), 1);
    }
  } catch (e) {
    console.log(e);
  }
};

export const pageLoadAnalytics = (pagePath: string): void => {
  const utagScript = document.getElementById('id-utag');
  const tagFunction = (): void => {
    const analyticsData = {
      page_name: buildPageName(pagePath),
      adobe_page_name: buildAdobePageName(pagePath),
      page_category: PAGE_CATEGORY,
    };
    setTimeout(() => {
      if (typeof window !== 'undefined') {
        window['utag'].view(analyticsData);
      }
    }, 500);
  };

  if (utagScript) {
    utagScript.onload = function () {
      if (typeof window !== 'undefined' && window['utag']) {
        tagFunction();
      }
    };
  }
  try {
    if (typeof window !== 'undefined' && window['utag']) {
      tagFunction();
    }
  } catch (e) {
    return;
  }
};

export const preparePageLoadAnalytics = (): void => {
  window['utag_cfg_ovrd'] = window['utag_cfg_ovrd'] || {};
  window['utag_cfg_ovrd'].noview = true;
};

export const clickAnalytics = (linkName: string) : void => {
  utagLink({ link_name: linkName });
};

export const formErrorAnalytics = (
  errors: Record<string, { message?: string } | undefined>,
  pageTag: string,
  errorLinkName: string
) : void => {
  const errorMessages = Object.values(errors)
    .filter(Boolean)
    .map((e) => e?.message)
    .filter(Boolean)
    .join('|');

  utagLink({
    link_name: errorLinkName,
    field_errors: `${pageTag}:${errorMessages}`,
    site_error: 1,
  });
};
